import type { CommandeRow } from '../types/commande.types';
import { filterItemsBySearchQuery } from './listSearch';

export const getCommandeSearchableValues = (commande: CommandeRow): string[] => [
  commande.numeroCommande,
  commande.numeroTracking,
  commande.clientPrenom,
  commande.clientNom,
  `${commande.clientPrenom} ${commande.clientNom}`.trim(),
];

export const filterCommandesBySearchQuery = (
  commandes: CommandeRow[],
  searchQuery: string,
): CommandeRow[] =>
  filterItemsBySearchQuery(commandes, searchQuery, getCommandeSearchableValues);

export const sortCommandesByPurchaseDate = (commandes: CommandeRow[]): CommandeRow[] =>
  [...commandes].sort(
    (left, right) => new Date(right.dateAchat).getTime() - new Date(left.dateAchat).getTime(),
  );
